import { useContext, useEffect, useMemo, useCallback, useState } from 'react';
import { useTheme } from '@emotion/react';
import { useNavigate } from 'react-router-dom';
import {
  BaseNewAndDetail,
  getDarkThemeClass,
} from '../../utility';
import { FarmContext } from '../../../context/FarmContext';
import apiService from '../../../api/apiService';
import { MetrcTransportersBreadCrumbs } from '../../utility/BreadcrumbLinks';
import _MetrcFacilityEmployeesTab from './_MetrcFacilityEmployeesTab';

export default function MetrcFacilityEmployees() {
  const [values, setValues] = useState();

  const { setFarmContextValue, farmContextValue } = useContext(FarmContext);
  const theme = useTheme();
  const navigate = useNavigate();

  const currDarkThemeClass = useMemo(() => getDarkThemeClass(theme), [theme]);

  const employeesKey = 'employees';
  const baseEntityName = 'Facility Employees';

  const tabEntityMap = [
    { key: employeesKey, label: 'Employees', validForNew: true, defaultForDetail: true },
  ];

  const currLinkLabel = 'Employees';
  const baseSaveBtnChildren = 'Add Employee';

  const breadcrumbsProps = {
    currLink: currLinkLabel,
    currDarkThemeClass,
    navigate,
  };
  
  const breadcrumbs = <MetrcTransportersBreadCrumbs {...breadcrumbsProps} />;

  useEffect(() => {
    const fetchedFarms = async () => {
      try {
        const response = await apiService.fetchInstance('farm/?fetch_farms=true');
        setFarmContextValue(response?.data || { farms: [] });
      } catch (error) {
        console.error('Error fetching farms', error);
        setFarmContextValue({ farms: [] });
      }
    };
    fetchedFarms();
  }, []);

  const handleSetValues = useCallback((prop, value) => {
    setValues((state) => ({ ...state, [prop]: value }));
  }, []);

  const toDisable = () => false;

  const getDefaultTabForEndpoint = () =>
    tabEntityMap?.find((tab) => tab?.defaultForDetail)?.key;

  const tabContentMap = {
    [employeesKey]: (
      <_MetrcFacilityEmployeesTab currDarkThemeClass={currDarkThemeClass} />
    ),
  };

  const baseProps = {
    baseEntityName,
    baseid: undefined,
    currDarkThemeClass,
    tabContentMap,
    tabEntityMap,
    breadcrumbs,
    createBaseEntityMsg: '',
    baseSaveBtnChildren,
    baseEndpointCheck: false,
    enablePopup: true,
    showSaveBtn: () => false,
    toDisable,
    getDefaultTabForEndpoint,
    handleSetValues,
  };

  return <BaseNewAndDetail {...baseProps} />;
}
